const dialogInjectionKey = Symbol("dialogInjectionKey");

export { dialogInjectionKey };
//# sourceMappingURL=constants.mjs.map
